import httpApi from "@src/utils/httpApi";
import {
  buildClientExportQueryParams,
  ClientExportFilters,
} from "@src/utils/clientExport";
import { AxiosResponse } from "axios";

export const downloadClientsCsv = (
  filters: ClientExportFilters = {}
): Promise<AxiosResponse<Blob>> => {
  const query = buildClientExportQueryParams(filters).toString();
  const url = query
    ? `/api/clients/export/csv?${query}`
    : "/api/clients/export/csv";

  return httpApi.get(url, {
    responseType: "blob",
  });
};
